import React from 'react';
import WbHttpClient from './wbhttpclient';

class IntegrationServices {
  constructor() {
    this.WbHttpClient = new WbHttpClient();
  }

  goalAlignPublish(params = {}) {
    return this.WbHttpClient.post('integration/goalAlighnPublish', params);
  }

  getMsPlannerData(params = {}) {
    return this.WbHttpClient.get('integration/queryExtProjects', params);
  }

  createMsOneNote(params = {}) {
    return this.WbHttpClient.get('integration/createMsOneNote', params);
  }
}

export default IntegrationServices;
